export let RangePatternType = /* @__PURE__ */ function(RangePatternType) {
	RangePatternType["startRange"] = "startRange";
	RangePatternType["shared"] = "shared";
	RangePatternType["endRange"] = "endRange";
	return RangePatternType;
}({});
